import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Grid,
  GridItem,
  SlideFade,
  useMultiStyleConfig,
  VStack,
} from '@chakra-ui/react';
import React from 'react';

import ImageHandler from '../ImageHandler';

interface DetailsBlockProps {
  title: string;
  image: StaticImageDef | React.ReactElement;
  summaryContent: React.ReactElement;
  detailContent: React.ReactElement;
}

const DetailsBlock: React.FC<DetailsBlockProps> = ({
  title,
  image,
  summaryContent,
  detailContent,
}) => {
  const Styles = useMultiStyleConfig('DetailsBlock', {});

  const [expanded, setExpanded] = React.useState(false);
  const toggleExpanded = React.useCallback(
    () => setExpanded((cur) => !cur),
    [],
  );

  return (
    <VStack sx={Styles.container} spacing={4}>
      <Box as="h3" sx={Styles.title}>
        {title}
      </Box>
      <Grid sx={Styles.content}>
        <GridItem sx={Styles.image}>
          <ImageHandler image={image} />
        </GridItem>
        <GridItem sx={Styles.summary}>{summaryContent}</GridItem>
        <GridItem colSpan={[1, null, null, 2]}>
          <Box as={SlideFade} in={expanded} unmountOnExit sx={Styles.details}>
            {detailContent}
          </Box>
        </GridItem>
      </Grid>
      <Button
        sx={Styles.button}
        leftIcon={
          expanded ? (
            <ChevronUpIcon boxSize="1em" />
          ) : (
            <ChevronDownIcon boxSize="1em" />
          )
        }
        variant="ghost"
        onClick={toggleExpanded}
      >
        {expanded ? 'Hide Details' : 'Show Details'}
      </Button>
    </VStack>
  );
};

export default DetailsBlock;
